import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import ConnectedAccountsSection from '../components/connected-accounts-section.tsx';
import DeleteAccountSection from '../components/delete-account-section.tsx';
import ProfileSection from '../components/profile-section.tsx';
import SecuritySection from '../components/security-section.tsx';
import { PasswordSection } from './settings.tsx';
import { useSession } from '../state/session.tsx';
import { authApi } from '../api/endpoints.ts';

export default function CrewAccountPage() {
  const { t } = useTranslation();
  const { user, refresh } = useSession();
  const password = useMutation({
    mutationFn: (payload: { currentPassword?: string; newPassword: string }) => authApi.changePassword(payload),
    onSuccess: () => void refresh(),
  });
  return (
    <>
      <h1 className="mb-6 text-2xl font-bold">{t('crew.account')}</h1>
      <SecuritySection />
      <ProfileSection />
      <ConnectedAccountsSection returnTo="/crew-account" />
      <PasswordSection
        hasPassword={user?.hasPassword ?? true}
        onSubmit={(payload) => password.mutateAsync(payload)}
        busy={password.isPending}
      />
      <DeleteAccountSection />
    </>
  );
}
